module.exports = __webpack_public_path__ + "media/files/www/TERMS_AND_CONDITIONS_OF_USE_GETPICA-BRELLA.pdf";